import type { HelpFile } from '../../types/help'
import { RequestInspectorDetailTestIds } from '../../../testids/RequestInspectorDetailTestIds'

export const requestInspectorDetailHelp: HelpFile = {
  docPage: '/docs/observability/request-inspector',
  texts: {
    [RequestInspectorDetailTestIds.requestInspectorDetailPage]:
      'Aufgezeichnete Anfrage im Detail — nachgelagerte Spans, SQL-Aktivität und Zeitaufschlüsselung.',
    [RequestInspectorDetailTestIds.btnDownloadTrace]:
      'Vollständigen Trace als JSON herunterladen — für Offline-Analyse oder Weitergabe an den Support.',
    [RequestInspectorDetailTestIds.cardTitleDetail]:
      'Kernattribute der aufgezeichneten Anfrage — URL, Methode, Statuscode und Dauer.',
    [RequestInspectorDetailTestIds.cardTitleRequests]:
      'Nachgelagerte Anfragen und Aufrufe während der Bearbeitung.',
    [RequestInspectorDetailTestIds.colDuration]:
      'Dauer der Anfrage oder des Spans.',
    [RequestInspectorDetailTestIds.colMethod]: null,
    [RequestInspectorDetailTestIds.colSqlCount]:
      'Anzahl der in diesem Span ausgeführten SQL-Anweisungen.',
    [RequestInspectorDetailTestIds.colSqlTime]:
      'Kumulierte SQL-Zeit in diesem Span.',
    [RequestInspectorDetailTestIds.colStatus]: null,
    [RequestInspectorDetailTestIds.colUrl]: null,
    [RequestInspectorDetailTestIds.requestsTable]:
      'Alle aufgezeichneten Anfragen dieses Trace.',
  },
}
